module.exports = __webpack_public_path__ + "images/assets/9fb86549081e9a67b92986e8cfc4021e.svg";